import { render } from "./CPSR.vue?vue&type=template&id=1c6b4d9c&scoped=true"
import script from "./CPSR.vue?vue&type=script&lang=js"
export * from "./CPSR.vue?vue&type=script&lang=js"

import "./CPSR.vue?vue&type=style&index=0&id=1c6b4d9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6b4d9c"],['__file',"src/components/CPSR.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c6b4d9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c6b4d9c', __exports__)) {
    api.reload('1c6b4d9c', __exports__)
  }
  
  module.hot.accept("./CPSR.vue?vue&type=template&id=1c6b4d9c&scoped=true", () => {
    api.rerender('1c6b4d9c', render)
  })

}


export default __exports__